import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-navy text-white" data-testid="footer">
      <div className="max-w-8xl mx-auto px-6 md:px-12 py-16 grid grid-cols-1 md:grid-cols-3 gap-12">
        <div>
          <div className="inline-flex bg-white px-4 py-3 rounded-sm">
            <img src="/logo-mp.png" alt="Martegiani Petroli Srl" className="h-11 w-auto" />
          </div>
          <p className="text-white/50 text-sm mt-5 leading-relaxed max-w-xs">
            Distribuzione di gasolio e lubrificanti per aziende, agricoltura e autotrazione.
            Affidabilità e solidità dal territorio abruzzese.
          </p>
        </div>

        <div className="space-y-3 text-sm">
          <p className="text-[11px] uppercase tracking-[0.25em] text-orange font-semibold mb-4">
            Contatti
          </p>
          <a href="tel:0861598527" className="flex items-center gap-3 text-white/70 hover:text-white transition-colors">
            <Phone className="w-4 h-4 text-orange" /> 0861-598527
          </a>
          <a href="mailto:info@martegianipetroli.it" className="flex items-center gap-3 text-white/70 hover:text-white transition-colors">
            <Mail className="w-4 h-4 text-orange" /> info@martegianipetroli.it
          </a>
          <p className="flex items-start gap-3 text-white/70">
            <MapPin className="w-4 h-4 text-orange mt-0.5 shrink-0" />
            Viale Luigi Settembrini 63, Montorio al Vomano (TE) 64046
          </p>
          <p className="flex items-start gap-3 text-white/70">
            <Clock className="w-4 h-4 text-orange mt-0.5 shrink-0" />
            Lun–Ven 07:00–12:30 · 15:30–18:30
          </p>
        </div>

        <div className="space-y-3 text-sm">
          <p className="text-[11px] uppercase tracking-[0.25em] text-orange font-semibold mb-4">
            Navigazione
          </p>
          <a href="/#chi-siamo" className="block text-white/70 hover:text-white transition-colors">Chi Siamo</a>
          <a href="/#cataloghi" className="block text-white/70 hover:text-white transition-colors">Cataloghi Olii</a>
          <a href="/#preventivi" className="block text-white/70 hover:text-white transition-colors">Preventivi Gasolio</a>
          <Link to="/privacy-policy" data-testid="footer-privacy-link" className="block text-white/70 hover:text-white transition-colors">Privacy Policy</Link>
          <Link to="/admin/login" data-testid="footer-admin-link" className="block text-white/40 hover:text-orange transition-colors">Area Riservata</Link>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-8xl mx-auto px-6 md:px-12 py-8" data-testid="zone-consegna">
          <p className="text-[11px] uppercase tracking-[0.25em] text-orange font-semibold mb-4">
            Zone di Consegna
          </p>
          <p className="text-white/60 text-sm max-w-3xl leading-relaxed mb-3">
            Consegna di gasolio, lubrificanti e AdBlue a Teramo (capoluogo), Montorio al Vomano (nostra sede)
            e in tutti i comuni della provincia di Teramo:
          </p>
          <p className="text-[11px] leading-relaxed text-white/40 max-w-5xl">
            {["Teramo", "Alba Adriatica", "Ancarano", "Arsita", "Atri", "Basciano", "Bellante", "Bisenti",
              "Campli", "Canzano", "Castel Castagna", "Castellalto", "Castelli", "Castiglione Messer Raimondo",
              "Castilenti", "Cellino Attanasio", "Cermignano", "Civitella del Tronto", "Colledara", "Colonnella",
              "Controguerra", "Corropoli", "Cortino", "Crognaleto", "Fano Adriano", "Giulianova",
              "Isola del Gran Sasso d'Italia", "Martinsicuro", "Montefino", "Montorio al Vomano", "Morro d'Oro",
              "Mosciano Sant'Angelo", "Nereto", "Notaresco", "Penna Sant'Andrea", "Pietracamela", "Pineto",
              "Rocca Santa Maria", "Roseto degli Abruzzi", "Sant'Egidio alla Vibrata", "Sant'Omero", "Silvi",
              "Torano Nuovo", "Torricella Sicura", "Tortoreto", "Tossicia", "Valle Castellana"].join(" · ")}
          </p>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-8xl mx-auto px-6 md:px-12 py-6 space-y-4">
          <p className="text-[11px] leading-relaxed text-white/40 max-w-4xl" data-testid="footer-disclaimer">
            Martegiani Petroli Srl opera come distributore indipendente. I marchi Shell, IP, Tamoil,
            Petronas e Brenntag citati nel sito appartengono ai legittimi proprietari e sono utilizzati
            al solo scopo di descrivere i prodotti commercializzati. Martegiani Petroli Srl non è legata
            da rapporti di agenzia o rappresentanza diretta con i suddetti marchi.
          </p>
          <div className="border-t border-white/5 pt-4 space-y-3">
            <p className="text-[11px] leading-relaxed text-white/40" data-testid="footer-legal">
              MARTEGIANI PETROLI S.R.L. — Sede legale: Via L. Settembrini 42, 64046 Montorio al Vomano (TE) ·
              P.IVA e C.F. 00587270679 · REA TE-82086 · Registro Imprese di Teramo n. 00587270679 ·
              Capitale sociale € 98.800,00 i.v. · PEC: martegiani.petroli@pec.it
            </p>
            <div className="flex flex-col sm:flex-row justify-between gap-2 text-xs text-white/40">
              <span>© {new Date().getFullYear()} Martegiani Petroli Srl. Tutti i diritti riservati.</span>
              <span>Montorio al Vomano (TE)</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
